'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MobileNavContextProps {
  isMobileNavVisible: boolean;
  setMobileNavVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileNavContext = createContext<MobileNavContextProps | undefined>(
  undefined
);

export function MobileNavProvider({ children }: { children: ReactNode }) {
  const [isMobileNavVisible, setMobileNavVisible] = useState<boolean>(true);

  return (
    <MobileNavContext.Provider
      value={{
        isMobileNavVisible,
        setMobileNavVisible,
      }}
    >
      {children}
    </MobileNavContext.Provider>
  );
}

export function useMobileNav() {
  const context = useContext(MobileNavContext);
  if (context === undefined) {
    throw new Error('useMobileNav must be used within a MobileNavProvider');
  }
  return context;
}
